import { render, staticRenderFns } from "./tempChats.vue?vue&type=template&id=17f86a1b&scoped=true"
import script from "./tempChats.vue?vue&type=script&lang=js"
export * from "./tempChats.vue?vue&type=script&lang=js"
import style0 from "./tempChats.vue?vue&type=style&index=0&id=17f86a1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f86a1b",
  null
  
)

export default component.exports